import { render, staticRenderFns } from "./qualityInspectionList.vue?vue&type=template&id=1f0ab13a"
import script from "./qualityInspectionList.vue?vue&type=script&lang=js"
export * from "./qualityInspectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports